export const IMG_PATH = IMG_URL + "/public/img/anlaut/";
export const LOGO_PATH = IMG_URL + "/public/img/logos/";
export const IMG_PATH_MINIFIED = IMG_URL + "/public/img/minified/";
export const IMG_ENDING = "-min.png";
export const AUDIO_PATH = IMG_URL + "/public/audio/";
export const AUDIO_ENDING = ".mp3";
export const SONDER_LAUTE = ["n_", "oe", "ae", "ue", "scharfes_s"];
